import styled from '@emotion/styled';
import { Spacings } from '@styles/index';

const Wrapper = styled.div`
  & .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
    margin-right: ${Spacings.SPACING_2};
  }

  & .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
    margin-right: ${Spacings.SPACING_2};
  }
`;

const DotLoader = styled.div`
  width: ${Spacings.SPACING_3B};
  height: ${Spacings.SPACING_3B};
  background-color: ${({ showWhiteLoader }) =>
    showWhiteLoader ? 'var(--color-base-1)' : 'var(--color-text-primary)'};
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1s infinite ease-in-out both;

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0.5);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
`;

const BounceLoader = ({ showWhiteLoader = false }) => {
  return (
    <Wrapper>
      <DotLoader showWhiteLoader={showWhiteLoader} className="bounce1" />
      <DotLoader showWhiteLoader={showWhiteLoader} className="bounce2" />
      <DotLoader showWhiteLoader={showWhiteLoader} className="bounce3" />
    </Wrapper>
  );
};

export default BounceLoader;
